const DEFAULT_WORDS_COUNT = 200;
const COUNT_DOWN_90 = 90;
const COUNT_DOWN_60 = 60;
const COUNT_DOWN_30 = 30;
const COUNT_DOWN_15 = 15;
const DEFAULT_COUNT_DOWN = COUNT_DOWN_60;

const RESTART_BUTTON_TOOLTIP_TITLE = "[Tab] + [Enter] to quickly restart";
const REDO_BUTTON_TOOLTIP_TITLE = "[Tab] + [Space] to quickly redo";
const RESTART_BUTTON_TOOLTIP_TITLE_WORDSCARD =
  "[Tab] + [Enter] to quick restart the chapter";

const WORD_MODE_LABEL = "word";

const PACING_CARET = "caret";
const PACING_PULSE = "pulse";

const PACING_CARET_TOOLTIP =
  'type the word with a caret "|" , character by character.';
const PACING_PULSE_TOOLTIP =
  'type the word with a pulse "____", this helps improving wpm and your speed typing pace habit.';

export {
  DEFAULT_WORDS_COUNT,
  DEFAULT_COUNT_DOWN,
  COUNT_DOWN_60,
  COUNT_DOWN_30,
  COUNT_DOWN_15,
  COUNT_DOWN_90,
  RESTART_BUTTON_TOOLTIP_TITLE,
  REDO_BUTTON_TOOLTIP_TITLE,
  WORD_MODE_LABEL,
  RESTART_BUTTON_TOOLTIP_TITLE_WORDSCARD,
  PACING_CARET,
  PACING_PULSE,
  PACING_CARET_TOOLTIP,
  PACING_PULSE_TOOLTIP,
};
